export const ADD_UNREAD_BOOLEAN = 'ADD_UNREAD_BOOLEAN';
export const addUnreadBooleanAction = (unreadBoolean) => {
  return { type: ADD_UNREAD_BOOLEAN, unreadBoolean };
};
